import CheckBox from 'admin/components/atoms/CheckBox';
import Headings from 'admin/components/atoms/Headings';
import Table from 'admin/components/atoms/Table';
import { TableCell, TableHeader, TableRow } from 'admin/components/atoms/Tables';
import Pager from 'admin/components/shared/Pager';
import { formatDate, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FormWrapper = styled.div`
  margin: 5px;
`;

const RowWrapper = styled.div`
  max-height: calc(75vh - 210px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-left: solid 1px #ececec;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    box-shadow: inset 0 0 0 2px #fff;
  }
`;

const CustomerSelector = ({
  customers,
  pagination,
  checkboxRef,
  onChangeCheckbox,
  onCheckAll,
  onChangePage,
  checkedIds,
}) => {
  const [allChecked, setAllChecked] = useState(false);

  const handleCheckAll = (checked) => {
    setAllChecked(checked);
    onCheckAll(checked);
  };

  const handlePageChange = (page) => {
    onChangePage(page);
    setAllChecked(false);
  };

  const makeHeader = () => (
    <TableHeader>
      <TableCell size="1">
        <CheckBox
          style={{ margin: 5 }}
          setChecked={handleCheckAll}
          checked={allChecked}
          disabled={customers.length <= 0}
        />
        <Headings.h6>全て選択</Headings.h6>
      </TableCell>
      <TableCell size="1">
        <Headings.h6>お客様ID</Headings.h6>
      </TableCell>
      <TableCell size="2">
        <Headings.h6>ニックネーム</Headings.h6>
      </TableCell>
      <TableCell size="2">
        <Headings.h6>携帯電話番号</Headings.h6>
      </TableCell>
      <TableCell size="3">
        <Headings.h6>メールアドレス</Headings.h6>
      </TableCell>
      <TableCell size="2">
        <Headings.h6>会員登録日時</Headings.h6>
      </TableCell>
    </TableHeader>
  );

  const customersToTableRow = (receiver) => (
    <TableRow key={receiver.id}>
      <TableCell size="1">
        <CheckBox
          onChange={onChangeCheckbox}
          value={receiver.id}
          checked={checkedIds.includes(receiver.id)}
        />
      </TableCell>
      <TableCell size="1">
        <Link to={`/customers/${receiver.id}`}>{formatUUID(receiver.id)}</Link>
      </TableCell>
      <TableCell size="2">{receiver.name}</TableCell>
      <TableCell size="2">{receiver.tel}</TableCell>
      <TableCell size="3">{receiver.email}</TableCell>
      <TableCell size="2">{formatDate(receiver.registered_at)}</TableCell>
      <TableCell size="2">
        {receiver.last_send_message_at ? formatDate(receiver.last_send_message_at) : '-'}
      </TableCell>
    </TableRow>
  );

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell width="40px" align="center">
            <CheckBox
              style={{ margin: 5 }}
              setChecked={handleCheckAll}
              checked={allChecked}
              disabled={customers.length <= 0}
            />
          </Table.Cell>
          <Table.Cell size="1">お客様ID</Table.Cell>
          <Table.Cell size="3">ニックネーム</Table.Cell>
          <Table.Cell size="2">携帯電話番号</Table.Cell>
          <Table.Cell>メールアドレス</Table.Cell>
          <Table.Cell size="1.5">会員登録日時</Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {customers?.map((receiver) => (
          <Table.Row key={receiver.id}>
            <Table.Cell align="center">
              <CheckBox
                onChange={onChangeCheckbox}
                value={receiver.id}
                checked={checkedIds.includes(receiver.id)}
              />
            </Table.Cell>
            <Table.Cell wordBreak="keep-all">
              <Link to={`/customers/${receiver.id}`}>{formatUUID(receiver.id)}</Link>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">{receiver.name}</Table.Cell>
            <Table.Cell>{receiver.tel}</Table.Cell>
            <Table.Cell wordBreak="break-word">{receiver.email}</Table.Cell>
            <Table.Cell styles={{ wordSpacing: '100vw' }}>
              {formatDate(receiver.registered_at)}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      {!!pagination && (
        <Table.Footer>
          <Table.Row noBorder>
            <Table.Cell colSpan={6} align="center" styles={{ paddingTop: '16px' }}>
              <Pager pagination={pagination} onChangePage={onChangePage} />
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

CustomerSelector.propTypes = {
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tel: PropTypes.string,
      registered_at: PropTypes.string,
      last_transaction_at: PropTypes.string,
    })
  ),
  onChangeCheckbox: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  checkedIds: PropTypes.array.isRequired,
};

CustomerSelector.defaultProps = {
  customers: [],
};

export default CustomerSelector;
